import { chatHistoryBGColor } from 'globals/colors';

const styles = {
  alley: {
    padding: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: chatHistoryBGColor,
    flex: '1 1 auto',
  },
};

export default styles;
